import { navigate } from '@reach/router'
import api from 'api'
import {
	getCachedUser,
	removeCachedUser,
	setCachedUser
} from 'helpers/cachedUser'
import nProgress from 'nprogress'

/**
 * Checks the validity of the current session and refreshes the token if the session has expired
 * @returns Valid access token
 */
export const validateSession = async () => {
	const user = getCachedUser()

	if (!user) {
		clearSession()
		throw new Error('Invalid session')
	}

	const sessionExpired = new Date(user.tokenExpiry) < new Date()
	if (sessionExpired) {
		return refreshSession()
	}

	return user.token
}

/**
 * Refreshes the user session and returns the new access token
 */
export const refreshSession = async () => {
	try {
		const user = getCachedUser()
		if (user) {
			const {
				data: {
					user: { id, roles },
					access
				}
			} = await api.auth.tokenRefresh({
				userId: user.id,
				token: user.refreshToken
			})
			setCachedUser({ id, roles, ...access })
			return Promise.resolve(access.token)
		}
		throw new Error('Unable to refresh session')
	} catch (err) {
		clearSession()
		return Promise.reject(err)
	}
}

/**
 * Clears the user cache & redirects user to login
 */
export const clearSession = () => {
	removeCachedUser()
	const { pathname } = window.location
	navigate(pathname === '/login' ? pathname : `/login?redirectUrl=${pathname}`)
	nProgress.done()
}
